/**
 * Stable CSS class names for E2E — Grow Working Days.
 */
export const GWD = {
    page: 'grow-working-days-page',
    breadcrumbSection: 'grow-working-days-page__breadcrumb-section',
    loadingSection: 'grow-working-days-page__loading-section',
    contentSection: 'grow-working-days-page__content-section',
    workingHoursSection: 'grow-working-days-page__working-hours-section',
    activeCountBanner: 'grow-working-days-page__active-count-banner',
    calendarGrid: 'grow-working-days-page__calendar-grid',
    dayCard: 'grow-working-days-page__day-card',
    dayCardSelected: 'grow-working-days-page__day-card--selected',
    dayCardHover: 'grow-working-days-page__day-card--hover',
    footerSection: 'grow-working-days-page__footer-section',
    inputButtonClear: 'grow-working-days-page-input--button-clear',
    inputButtonSave: 'grow-working-days-page-input--button-save',
    startHourInput: 'grow-working-days-page-input--start-hour',
    endHourInput: 'grow-working-days-page-input--end-hour',
} as const;
